/*
 * @Author: baihaoyu baihaoyu@ucanit.cn
 * @Date: 2021-05-11 13:09:44
 * @LastEditors: baihaoyu baihaoyu@ucanit.cn
 * @LastEditTime: 2023-03-16 11:43:32
 * @FilePath: \hp-njroad-wechat\src\common\constants.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  home: "南京东路街道智慧养老平台",
  service: "养老服务",
  agency: "机构",
  user: "我的个人中心",
  map: "机构",
  policeInfo: "政策资讯",
  policeDetail: "政策详情",
  applicationRecord: "申请记录",
  careConsultant: "智能养老顾问",
  queryResult: "查询结果",
  serviceDetail: "助浴服务",
  applyOnline: "申请助浴服务",
  applyService: "申请助浴服务",
  personInfo: "个人信息",
  familyApply: "请选择家人",
  addFamily: "添加家人",
  myFamily: "我的家人",
  agencyList: "老年日托所",
  agencyDetail: "机构详情",
  enjoyedService: "已享受的服务",
  recordDetail: "申请记录详情",
  familyInfo: "家人信息",
  foodAid: "助餐点",
  thirdDetail: "上海黄浦区安逸的养老院",
  thirdList: "第三方服务",
  login: "请登录",
  agreement: "用户服务协议",
  privacy: "隐私政策"
};
export const areaCode = "310101002000";
export const committee = {
  云中居委: "310101002001",
  龙泉居委: "310101002002",
  贵州居委: "310101002003",
  新桥居委: "310101002006",
  牛庄居委: "310101002007",
  厦门居委: "310101002008",
  福海居委: "310101002009",
  承兴居委: "310101002010",
  三德居委: "310101002011",
  福瑞居委: "310101002013",
  平望居委: "310101002014",
  小花园居委: "310101002015",
  长江居委: "310101002017",
  江阴居委: "310101002018",
  均乐居委: "310101002019",
  新昌居委: "310101002020",
  振兴居委: "310101002021",
  定兴居委: "310101002022",
  顺天村居委: "310101002023"
};

export const orgType = {
  1010: "养老院",
  1011: "长者照护之家",
  2011: "综合为老服务中心",
  2025: "睦邻中心",
  2026: "适老化智慧养老体验中心",
  2010: "老年日托所",
  2014: "助餐点",
  2024: "社区为老服务站",
  2027: "长者运动健康之家",
  2013: "老年活动室",
  2022: "社区养老服务站",
  2015: "社区长者食堂" 
};

export const pageModel = {
  pageNum: 1,
  pageSize: 6
};
